import { render, staticRenderFns } from "./topicOne.vue?vue&type=template&id=71beeabf&scoped=true&"
import script from "./topicOne.vue?vue&type=script&lang=js&"
export * from "./topicOne.vue?vue&type=script&lang=js&"
import style0 from "./topicOne.vue?vue&type=style&index=0&id=71beeabf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71beeabf",
  null
  
)

export default component.exports